import React, { useState } from 'react';

import { Menu, Collapse } from 'antd';

import { GiMedicalPackAlt } from 'react-icons/gi';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import { GoMegaphone } from 'react-icons/go';
import { BiBuildings } from 'react-icons/bi';
import MenuHealth from './subcomponents/MenuHealth';
import MenuAgencies from './subcomponents/MenuAgencies';
import MenuCommercial from './subcomponents/MenuCommercial';

const { Panel } = Collapse;
function MenuPage() {
  const [active, setActive] = useState('health');

  const initNavMenu = [
    {
      key: '1',
      type: 'health',
      label: 'Healthcare',
      icon: <GiMedicalPackAlt className='collapse-header-cont-icon' />,
    },
    {
      key: '2',
      type: 'agencies',
      label: ' Agencies / Brands',
      icon: <GoMegaphone className='collapse-header-cont-icon' />,
    },
    {
      key: '3',
      type: 'commercial',
      label: 'Commercial',
      icon: <BiBuildings className='collapse-header-cont-icon' />,
    },
  ];
  return (
    <>
      <section
        id='services'
        className='menu_container d-flex-col justify-content-center align-items-center'
      >
        <div className='navbar d-flex-row align-items-center justify-content-center'>
          <Menu defaultSelectedKeys={['1']} mode='horizontal'>
            {initNavMenu.map((menu) => (
              <Menu.Item
                key={menu.key}
                icon={menu.icon}
                onClick={() => setActive(`${menu.type}`)}
              >
                {menu.label}
              </Menu.Item>
            ))}
          </Menu>
        </div>
        <MenuHealth
          isActive={active === 'health' ? 'tab-active' : 'tab-inactive'}
        />
        <MenuAgencies
          isActive={active === 'agencies' ? 'tab-active' : 'tab-inactive'}
        />
        <MenuCommercial
          isActive={active === 'commercial' ? 'tab-active' : 'tab-inactive'}
        />
        <Collapse
          accordion
          expandIconPosition={'right'}
          expandIcon={({ isActive }) =>
            isActive ? <MinusOutlined /> : <PlusOutlined />
          }
        >
          {initNavMenu.map((item) => {
            return (
              <Panel
                header={
                  <div className='collapse-header-cont'>
                    {item.icon}
                    <span className='collapse-header-cont-label text-title'>
                      {item.label}
                    </span>
                  </div>
                }
                key={item.key}
              >
                {item.type === 'health' && (
                  <MenuHealth isActive={'tab-active'} />
                )}
                {item.type === 'agencies' && (
                  <MenuAgencies isActive={'tab-active'} />
                )}
                {item.type === 'commercial' && (
                  <MenuCommercial isActive={'tab-active'} />
                )}
              </Panel>
            );
          })}
        </Collapse>
      </section>
    </>
  );
}

export default MenuPage;
